import React, { useEffect } from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { Home } from '../pages/Home';
import { Legal } from '../pages/Legal';
import { scrollToId } from '../lib/scroll';

function ScrollToHash(): React.ReactElement | null {
  const location = useLocation();

  useEffect(() => {
    if (location.pathname !== '/') return;
    if (!location.hash) return;

    const id = location.hash.replace('#', '');
    if (!id) return;

    // Allow route transition/render before scrolling
    window.setTimeout(() => scrollToId(id), 50);
  }, [location.pathname, location.hash]);

  return null;
}

export function App(): React.ReactElement {
  return (
    <>
      <ScrollToHash />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/privacy" element={<Legal title="Privacy Policy" />} />
        <Route path="/terms" element={<Legal title="Terms" />} />
      </Routes>
    </>
  );
}

